// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36MLy","col":"styles_col__2SDis"};